import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LuFilter } from "react-icons/lu";
import { M3IconButton } from "../components/m3";
import { useContextProvider } from "../components/page-context/ContextProvider";

/**
 * Standard toolbar actions for circularity tables: any extra controls, then
 * "Manage columns" (anchor for ColumnMenu) and "Refresh".
 *
 * @param {object} columnsAnchorRef - ref passed to ColumnMenu as anchorRef
 * @param {function} onToggleColumns - shows / hides the column menu
 * @param {boolean} showRefresh
 */
const CircularityTableActions = ({ columnsAnchorRef, onToggleColumns, showRefresh = true, children }) => {
  const { t } = useTranslation();
  const { setRefresh } = useContextProvider();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", justifyContent: "flex-end" }}>
      {children}
      {onToggleColumns && (
        <span ref={columnsAnchorRef} style={{ display: "inline-flex" }}>
          <M3IconButton size="sm" icon={<LuFilter size={16} />} tooltip={t("Manage Columns")} onClick={onToggleColumns} />
        </span>
      )}
      {showRefresh && (
        <M3IconButton
          size="sm"
          icon={<RefreshOutlinedIcon sx={{ fontSize: 18 }} />}
          tooltip={t("Refresh")}
          onClick={() => setRefresh((prev) => !prev)}
        />
      )}
    </Box>
  );
};

export default CircularityTableActions;
